export { default } from "./DimensionSemanticTypeLabel";
